'use client'

import { ReactNode, useLayoutEffect } from 'react'
import { createPortal } from 'react-dom'

import { ClientDataComponentIdentifier } from './types'
import useClientDataComponentContext from './useClientDataComponentContext'

type Props = {
  id: ClientDataComponentIdentifier
  component: ReactNode
}

const ClientDataComponentRegister = ({ id, component }: Props) => {
  const { element, setIsFallbackShown } = useClientDataComponentContext(id)

  useLayoutEffect(() => {
    setIsFallbackShown()
  }, [setIsFallbackShown])

  return element && createPortal(component, element)
}

export default ClientDataComponentRegister
